/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AgentCreateDTO } from '../models';
// @ts-ignore
import type { AgentResponseDTO } from '../models';
// @ts-ignore
import type { AgentUpdateDTO } from '../models';
// @ts-ignore
import type { Calendar } from '../models';
// @ts-ignore
import type { DelegationTargetBulkDTO } from '../models';
// @ts-ignore
import type { DelegationTargetCreateDTO } from '../models';
// @ts-ignore
import type { DelegationTargetResponseDTO } from '../models';
// @ts-ignore
import type { DelegationTargetUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageAgentResponseDTO } from '../models';
// @ts-ignore
import type { PromptTypeResponseDTO } from '../models';
/**
 * AgentsApi - axios parameter creator
 * @export
 */
export const AgentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost: async (agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost', 'agentId', agentId)
            // verify required parameter 'delegationTargetCreateDTO' is not null or undefined
            assertParamExists('addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost', 'delegationTargetCreateDTO', delegationTargetCreateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1: async (agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1', 'agentId', agentId)
            // verify required parameter 'delegationTargetCreateDTO' is not null or undefined
            assertParamExists('addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1', 'delegationTargetCreateDTO', delegationTargetCreateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost: async (agentId: string, calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost', 'agentId', agentId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost', 'calendarId', calendarId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars/{calendar_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2: async (agentId: string, calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2', 'agentId', agentId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2', 'calendarId', calendarId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars/{calendar_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentApiV1AgentsPost: async (agentCreateDTO: AgentCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreateDTO' is not null or undefined
            assertParamExists('createAgentApiV1AgentsPost', 'agentCreateDTO', agentCreateDTO)
            const localVarPath = `/api/v1/agents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentApiV1AgentsPost_3: async (agentCreateDTO: AgentCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreateDTO' is not null or undefined
            assertParamExists('createAgentApiV1AgentsPost_3', 'agentCreateDTO', agentCreateDTO)
            const localVarPath = `/api/v1/agents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentApiV1AgentsAgentIdDelete: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgentApiV1AgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentApiV1AgentsAgentIdDelete_4: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgentApiV1AgentsAgentIdDelete_4', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApiV1AgentsAgentIdGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentApiV1AgentsAgentIdGet', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApiV1AgentsAgentIdGet_5: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentApiV1AgentsAgentIdGet_5', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCalendarsApiV1AgentsAgentIdCalendarsGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentCalendarsApiV1AgentsAgentIdCalendarsGet', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsApiV1AgentsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsApiV1AgentsGet_7: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTypesApiV1AgentsTypesGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTypesApiV1AgentsTypesGet_9: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete: async (agentId: string, targetId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete', 'agentId', agentId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete', 'targetId', targetId)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets/{target_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10: async (agentId: string, targetId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10', 'agentId', agentId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10', 'targetId', targetId)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets/{target_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut: async (agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut', 'agentId', agentId)
            // verify required parameter 'delegationTargetBulkDTO' is not null or undefined
            assertParamExists('replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut', 'delegationTargetBulkDTO', delegationTargetBulkDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetBulkDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11: async (agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11', 'agentId', agentId)
            // verify required parameter 'delegationTargetBulkDTO' is not null or undefined
            assertParamExists('replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11', 'delegationTargetBulkDTO', delegationTargetBulkDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetBulkDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete: async (agentId: string, calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete', 'agentId', agentId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete', 'calendarId', calendarId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars/{calendar_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12: async (agentId: string, calendarId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12', 'agentId', agentId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12', 'calendarId', calendarId)
            const localVarPath = `/api/v1/agents/{agent_id}/calendars/{calendar_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"calendar_id"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentApiV1AgentsAgentIdPatch: async (agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentApiV1AgentsAgentIdPatch', 'agentId', agentId)
            // verify required parameter 'agentUpdateDTO' is not null or undefined
            assertParamExists('updateAgentApiV1AgentsAgentIdPatch', 'agentUpdateDTO', agentUpdateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentApiV1AgentsAgentIdPatch_13: async (agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentApiV1AgentsAgentIdPatch_13', 'agentId', agentId)
            // verify required parameter 'agentUpdateDTO' is not null or undefined
            assertParamExists('updateAgentApiV1AgentsAgentIdPatch_13', 'agentUpdateDTO', agentUpdateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch: async (agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch', 'agentId', agentId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch', 'targetId', targetId)
            // verify required parameter 'delegationTargetUpdateDTO' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch', 'delegationTargetUpdateDTO', delegationTargetUpdateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets/{target_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14: async (agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14', 'agentId', agentId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14', 'targetId', targetId)
            // verify required parameter 'delegationTargetUpdateDTO' is not null or undefined
            assertParamExists('updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14', 'delegationTargetUpdateDTO', delegationTargetUpdateDTO)
            const localVarPath = `/api/v1/agents/{agent_id}/delegation-targets/{target_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegationTargetUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentsApi - functional programming interface
 * @export
 */
export const AgentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelegationTargetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId, delegationTargetCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelegationTargetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId, delegationTargetCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId, calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId, calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentApiV1AgentsPost(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentApiV1AgentsPost(agentCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.createAgentApiV1AgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentApiV1AgentsPost_3(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentApiV1AgentsPost_3(agentCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.createAgentApiV1AgentsPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentApiV1AgentsAgentIdDelete(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentApiV1AgentsAgentIdDelete(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.deleteAgentApiV1AgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentApiV1AgentsAgentIdDelete_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentApiV1AgentsAgentIdDelete_4(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.deleteAgentApiV1AgentsAgentIdDelete_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentApiV1AgentsAgentIdGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentApiV1AgentsAgentIdGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgentApiV1AgentsAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentApiV1AgentsAgentIdGet_5(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentApiV1AgentsAgentIdGet_5(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgentApiV1AgentsAgentIdGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calendar>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calendar>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentsApiV1AgentsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentsApiV1AgentsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listAgentsApiV1AgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentsApiV1AgentsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentsApiV1AgentsGet_7(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listAgentsApiV1AgentsGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DelegationTargetResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DelegationTargetResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptTypesApiV1AgentsTypesGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptTypesApiV1AgentsTypesGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listPromptTypesApiV1AgentsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptTypesApiV1AgentsTypesGet_9(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptTypesApiV1AgentsTypesGet_9(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.listPromptTypesApiV1AgentsTypesGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId, targetId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId, targetId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DelegationTargetResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId, delegationTargetBulkDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DelegationTargetResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId, delegationTargetBulkDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId, calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId, calendarId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentApiV1AgentsAgentIdPatch(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentApiV1AgentsAgentIdPatch(agentId, agentUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.updateAgentApiV1AgentsAgentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentApiV1AgentsAgentIdPatch_13(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentApiV1AgentsAgentIdPatch_13(agentId, agentUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.updateAgentApiV1AgentsAgentIdPatch_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelegationTargetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId, targetId, delegationTargetUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelegationTargetResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId, targetId, delegationTargetUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentsApi - factory interface
 * @export
 */
export const AgentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentsApiFp(configuration)
    return {
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DelegationTargetResponseDTO> {
            return localVarFp.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId, delegationTargetCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a delegation target to an agent. Requires \'agent:write\' permission.
         * @summary Add Delegation Target
         * @param {string} agentId 
         * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DelegationTargetResponseDTO> {
            return localVarFp.addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId, delegationTargetCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId, calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a calendar to an agent. Requires \'agent:write\' permission.
         * @summary Assign Calendar To Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId, calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentApiV1AgentsPost(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.createAgentApiV1AgentsPost(agentCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new agent in the current organization. Requires \'agent:write\' permission.
         * @summary Create Agent
         * @param {AgentCreateDTO} agentCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentApiV1AgentsPost_3(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.createAgentApiV1AgentsPost_3(agentCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentApiV1AgentsAgentIdDelete(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentApiV1AgentsAgentIdDelete(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an agent from the organization. Requires \'agent:write\' permission.
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentApiV1AgentsAgentIdDelete_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentApiV1AgentsAgentIdDelete_4(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApiV1AgentsAgentIdGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.getAgentApiV1AgentsAgentIdGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific agent by ID. Requires \'agent:view\' permission.
         * @summary Get Agent
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApiV1AgentsAgentIdGet_5(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.getAgentApiV1AgentsAgentIdGet_5(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Calendar>> {
            return localVarFp.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all calendars associated with an agent. Requires \'agent:view\' permission.
         * @summary Get Agent Calendars
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Calendar>> {
            return localVarFp.getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsApiV1AgentsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAgentResponseDTO> {
            return localVarFp.listAgentsApiV1AgentsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
         * @summary List Agents
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsApiV1AgentsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageAgentResponseDTO> {
            return localVarFp.listAgentsApiV1AgentsGet_7(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DelegationTargetResponseDTO>> {
            return localVarFp.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all delegation targets for an agent. Requires \'agent:view\' permission.
         * @summary List Delegation Targets
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DelegationTargetResponseDTO>> {
            return localVarFp.listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTypesApiV1AgentsTypesGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTypeResponseDTO>> {
            return localVarFp.listPromptTypesApiV1AgentsTypesGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available prompt types for agents. Requires \'agent:view\' permission.
         * @summary List Prompt Types
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptTypesApiV1AgentsTypesGet_9(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTypeResponseDTO>> {
            return localVarFp.listPromptTypesApiV1AgentsTypesGet_9(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId, targetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a delegation target from an agent. Requires \'agent:write\' permission.
         * @summary Remove Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId, targetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DelegationTargetResponseDTO>> {
            return localVarFp.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId, delegationTargetBulkDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
         * @summary Replace Delegation Targets
         * @param {string} agentId 
         * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DelegationTargetResponseDTO>> {
            return localVarFp.replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId, delegationTargetBulkDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId, calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign a calendar from an agent. Requires \'agent:write\' permission.
         * @summary Unassign Calendar From Agent
         * @param {string} agentId 
         * @param {string} calendarId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId, calendarId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentApiV1AgentsAgentIdPatch(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.updateAgentApiV1AgentsAgentIdPatch(agentId, agentUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent\'s information. Requires \'agent:write\' permission.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdateDTO} agentUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentApiV1AgentsAgentIdPatch_13(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponseDTO> {
            return localVarFp.updateAgentApiV1AgentsAgentIdPatch_13(agentId, agentUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DelegationTargetResponseDTO> {
            return localVarFp.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId, targetId, delegationTargetUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
         * @summary Update Delegation Target
         * @param {string} agentId 
         * @param {string} targetId 
         * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DelegationTargetResponseDTO> {
            return localVarFp.updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId, targetId, delegationTargetUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentsApi - object-oriented interface
 * @export
 * @class AgentsApi
 * @extends {BaseAPI}
 */
export class AgentsApi extends BaseAPI {
    /**
     * Add a delegation target to an agent. Requires \'agent:write\' permission.
     * @summary Add Delegation Target
     * @param {string} agentId 
     * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost(agentId, delegationTargetCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a delegation target to an agent. Requires \'agent:write\' permission.
     * @summary Add Delegation Target
     * @param {string} agentId 
     * @param {DelegationTargetCreateDTO} delegationTargetCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId: string, delegationTargetCreateDTO: DelegationTargetCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).addDelegationTargetApiV1AgentsAgentIdDelegationTargetsPost_1(agentId, delegationTargetCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a calendar to an agent. Requires \'agent:write\' permission.
     * @summary Assign Calendar To Agent
     * @param {string} agentId 
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost(agentId, calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a calendar to an agent. Requires \'agent:write\' permission.
     * @summary Assign Calendar To Agent
     * @param {string} agentId 
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).assignCalendarToAgentApiV1AgentsAgentIdCalendarsCalendarIdPost_2(agentId, calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new agent in the current organization. Requires \'agent:write\' permission.
     * @summary Create Agent
     * @param {AgentCreateDTO} agentCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public createAgentApiV1AgentsPost(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).createAgentApiV1AgentsPost(agentCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new agent in the current organization. Requires \'agent:write\' permission.
     * @summary Create Agent
     * @param {AgentCreateDTO} agentCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public createAgentApiV1AgentsPost_3(agentCreateDTO: AgentCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).createAgentApiV1AgentsPost_3(agentCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an agent from the organization. Requires \'agent:write\' permission.
     * @summary Delete Agent
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public deleteAgentApiV1AgentsAgentIdDelete(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).deleteAgentApiV1AgentsAgentIdDelete(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an agent from the organization. Requires \'agent:write\' permission.
     * @summary Delete Agent
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public deleteAgentApiV1AgentsAgentIdDelete_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).deleteAgentApiV1AgentsAgentIdDelete_4(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific agent by ID. Requires \'agent:view\' permission.
     * @summary Get Agent
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgentApiV1AgentsAgentIdGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgentApiV1AgentsAgentIdGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific agent by ID. Requires \'agent:view\' permission.
     * @summary Get Agent
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgentApiV1AgentsAgentIdGet_5(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgentApiV1AgentsAgentIdGet_5(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all calendars associated with an agent. Requires \'agent:view\' permission.
     * @summary Get Agent Calendars
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgentCalendarsApiV1AgentsAgentIdCalendarsGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all calendars associated with an agent. Requires \'agent:view\' permission.
     * @summary Get Agent Calendars
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgentCalendarsApiV1AgentsAgentIdCalendarsGet_6(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
     * @summary List Agents
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listAgentsApiV1AgentsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listAgentsApiV1AgentsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all agents in the current user\'s organization. Requires \'agent:view\' permission.
     * @summary List Agents
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listAgentsApiV1AgentsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listAgentsApiV1AgentsGet_7(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all delegation targets for an agent. Requires \'agent:view\' permission.
     * @summary List Delegation Targets
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all delegation targets for an agent. Requires \'agent:view\' permission.
     * @summary List Delegation Targets
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listDelegationTargetsApiV1AgentsAgentIdDelegationTargetsGet_8(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available prompt types for agents. Requires \'agent:view\' permission.
     * @summary List Prompt Types
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listPromptTypesApiV1AgentsTypesGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listPromptTypesApiV1AgentsTypesGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available prompt types for agents. Requires \'agent:view\' permission.
     * @summary List Prompt Types
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public listPromptTypesApiV1AgentsTypesGet_9(authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).listPromptTypesApiV1AgentsTypesGet_9(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a delegation target from an agent. Requires \'agent:write\' permission.
     * @summary Remove Delegation Target
     * @param {string} agentId 
     * @param {string} targetId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete(agentId, targetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a delegation target from an agent. Requires \'agent:write\' permission.
     * @summary Remove Delegation Target
     * @param {string} agentId 
     * @param {string} targetId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId: string, targetId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).removeDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdDelete_10(agentId, targetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
     * @summary Replace Delegation Targets
     * @param {string} agentId 
     * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut(agentId, delegationTargetBulkDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all delegation targets for an agent. Requires \'agent:write\' permission.
     * @summary Replace Delegation Targets
     * @param {string} agentId 
     * @param {DelegationTargetBulkDTO} delegationTargetBulkDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId: string, delegationTargetBulkDTO: DelegationTargetBulkDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).replaceDelegationTargetsApiV1AgentsAgentIdDelegationTargetsPut_11(agentId, delegationTargetBulkDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign a calendar from an agent. Requires \'agent:write\' permission.
     * @summary Unassign Calendar From Agent
     * @param {string} agentId 
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete(agentId, calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign a calendar from an agent. Requires \'agent:write\' permission.
     * @summary Unassign Calendar From Agent
     * @param {string} agentId 
     * @param {string} calendarId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId: string, calendarId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).unassignCalendarFromAgentApiV1AgentsAgentIdCalendarsCalendarIdDelete_12(agentId, calendarId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent\'s information. Requires \'agent:write\' permission.
     * @summary Update Agent
     * @param {string} agentId 
     * @param {AgentUpdateDTO} agentUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public updateAgentApiV1AgentsAgentIdPatch(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).updateAgentApiV1AgentsAgentIdPatch(agentId, agentUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent\'s information. Requires \'agent:write\' permission.
     * @summary Update Agent
     * @param {string} agentId 
     * @param {AgentUpdateDTO} agentUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public updateAgentApiV1AgentsAgentIdPatch_13(agentId: string, agentUpdateDTO: AgentUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).updateAgentApiV1AgentsAgentIdPatch_13(agentId, agentUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
     * @summary Update Delegation Target
     * @param {string} agentId 
     * @param {string} targetId 
     * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch(agentId, targetId, delegationTargetUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a delegation target (enable/disable). Requires \'agent:write\' permission.
     * @summary Update Delegation Target
     * @param {string} agentId 
     * @param {string} targetId 
     * @param {DelegationTargetUpdateDTO} delegationTargetUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId: string, targetId: string, delegationTargetUpdateDTO: DelegationTargetUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).updateDelegationTargetApiV1AgentsAgentIdDelegationTargetsTargetIdPatch_14(agentId, targetId, delegationTargetUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

